<div class="navbar-brand">
  <img src="assets/img/pilka-icon.svg" width="25" height="25" alt="" />
</div>

<mat-nav-list>
  <a
    mat-list-item
    routerLink="/reservas"
    routerLinkActive="active"
    matTooltip="Reservas"
    [matTooltipPosition]="['after']"
    ><span class="material-icons">today</span></a
  >
  <a
    mat-list-item
    routerLink="/canchas"
    routerLinkActive="active"
    matTooltip="Canchas"
    [matTooltipPosition]="['after']"
    ><span class="material-icons">dashboard</span></a
  >
  <a
    mat-list-item
    routerLinkActive="active"
    matTooltip="Compras"
    [matTooltipPosition]="['after']"
    ><span class="material-icons">shopping_cart</span></a
  >
  <a
    mat-list-item
    routerLink="/giveaways"
    matTooltip="Sorteos y promociones"
    [matTooltipPosition]="['after']"
    routerLinkActive="router-link-active"
    routerLinkActive="active"
    ><span class="material-icons">trending_up</span></a
  >
  <a
    mat-list-item
    routerLink="players"
    matTooltip="Jugadores"
    [matTooltipPosition]="['after']"
    routerLinkActive="active"
    ><span class="material-icons">people</span></a
  >
  <a
    mat-list-item
    routerLink="/feedback"
    matTooltip="Comunicaciones"
    [matTooltipPosition]="['after']"
    routerLinkActive="active"
    ><span class="material-icons">question_answer</span></a
  >
  <a
    mat-list-item
    routerLink="/health"
    matTooltip="Salud"
    [matTooltipPosition]="['after']"
    routerLinkActive="active"
    ><span class="material-icons">favorite</span></a
  >
  <a
    mat-list-item
    routerLink="/tournaments"
    matTooltip="Torneos"
    [matTooltipPosition]="['after']"
    routerLinkActive="active"
    ><span class="material-icons">emoji_events</span></a
  >
</mat-nav-list>

<div class="flex-spacer"></div>

<div class="navbar-section navbar-bottom">
  <div class="nav-item">
    <span class="material-icons">settings</span>
  </div>
</div>
